



































































import ProductListLayout from "./ProductListLayout.vue";
import ProductTile from "./ProductTile.vue";
import FilterBar from "./FilterBar.vue";
import ActiveFilters from "./ActiveFilters.vue";
import FilterOverlay from "./FilterOverlay.vue";
import Config, { Mode } from '@/models/config.model';
import Product from '@/models/product.model';
import FilterGroup from '@/models/filter-group.model';
import Translations from '@/models/translations.model';

export default {
  name: "ProductList",
  components: {
    ProductListLayout,
    ProductTile,
    FilterBar,
    ActiveFilters,
    FilterOverlay,
  },
  data() {
    return {
      productTileModule: null,
      isInitialized: false,
    };
  },
  computed: {
    config(): Config {
      return this.$store.state.config;
    },
    isMatnoMode(): boolean {
      return this.config.mode === Mode.Matno;
    },
    isMatnoReducedMode(): boolean {
      return this.config.mode === Mode.MatnoReduced;
    },
    /**
     * Returns an array of filter groups
     */
    filters(): Array<FilterGroup> {
      return this.$store.state.filters;
    },
    /**
     * Returns the product sorting
     */
    productSorting(): string {
      return this.$store.state.productSorting;
    },
    /**
     * Returns an array of products based
     * on filtering, sorting and chunking
     **/
    chunkedProducts(): Array<Product> {
      return this.$store.getters.chunkedProducts;
    },
    /**
     * Returns the length
     * of the limited products
     * array
     */
    chunkedProductsLength(): number {
      return this.chunkedProducts.length;
    },
    /**
     * Returns the length
     * of the filtered products
     * array
     */
    totalProductsLength(): number {
      return this.$store.getters.sortedProducts.length;
    },
    /**
     * Returns the percentage
     * CSS width string
     * for the progress bar 
     **/
    progressBarWidth(): string {
      const decimal = this.chunkedProductsLength / this.totalProductsLength;
      const clampedDecimal = Math.min(1, Math.max(decimal, 0));
      const percentage = clampedDecimal * 100;
      const cssWidth = `${percentage}%`;
      return cssWidth;
    },
    translations(): Translations {
      return this.$store.state.translations;
    },
    seenAllResultsText(): string {
      return this.translations.seenAllResults
        .replace("{PRODUCTS_COUNT}", this.totalProductsLength);
    },
    seenFromResultsText(): string {
      return this.translations.seenFromResults
        .replace("{PRODUCTS_SEEN_COUNT}", this.chunkedProductsLength)
        .replace("{PRODUCTS_COUNT}", this.totalProductsLength);
    },
  },
  methods: {
    async init() {
      const [productListingInstance, productTileModule] = await Promise.all([
        this.createProductListingInstance(),
        this.loadProductTileModule(),
      ]);

      this.productListingInstance = productListingInstance;
      this.productTileModule = productTileModule;
      this.isInitialized = true;
      window.Miele.Footnotes.ready().then(function (footnotes) {
        footnotes.addContentArea('#product-filter-app');
      });
    },
    /**
     * Loads the product listing module
     * using the ModuleLoader and creates
     * an instance
     */
    createProductListingInstance() {
      return Miele.ModuleLoader.createModuleInstance("pwp:modules/products/listing", this.$el, {
        initTiles: false
      });
    },
    /**
     * Imports the product tile module
     * using the ModuleLoader so
     * it can be passed to the product tiles
     */
    async loadProductTileModule() {
      return Miele.ModuleLoader.importModule("pwp:modules/products/tile");
    },
    /**
     * Trigger increment of the productLimit
     **/
    showMoreProducts(): void {
      this.$store.dispatch("showMoreProducts");
    },
    /**
     * Show all products
     */
    showAllProducts(): void {
      this.$store.dispatch("showAllProducts");
    },
    /**
     * Handles the 'sort-change'
     * event of the ProductFilterBar
     * component
     **/
    handleSortChange(productSorting: string): void {
      this.$store.dispatch("setProductSorting", productSorting);
    },
  },
  mounted() {
    this.init();
  }
};
